import { Dispatcher } from 'flux';

global.window.showPlanningDispatcher = new Dispatcher();
